import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { HeadBlock } from '../../atoms/head-block';
import { Description } from '../../atoms/description';
import { CheckoutPanel, OrderSummarySection } from './checkout-panel';
import { AdSlotRow } from '../../../../collection-templates/ad-slot-row';
import { CustomWidgetRow } from '../../../../collection-templates/custom-widget-row';
import './loginless-common.m.css';

const isSubscriptionRow = (row) =>
  ['Concrete', 'Minimalist', 'LoginlessFlat', 'LoginlessGrouped', 'Lavish'].includes(row?.layout) ||
  row?.type === 'subscription' ;

const isAdRow = (row) => row?.type === 'ads';

const isWidgetRow = (row) => row?.type === 'widget';

const renderRow = (row, index) => {
  if (!row) return null;
  const key = row.rowId || `sub-row-${index}`;

  if (isWidgetRow(row)) {
    return <CustomWidgetRow metadata={row} key={key} />;
  }

  if (isAdRow(row)) {
    return <AdSlotRow metadata={row} key={key} />;
  }

  return null;
};

export const LoginlessLayout = ({
  children,
  subscriptionConfig,
  mode,
  isPB,
  activePlan,
  description,
  descriptionType = 'plan',
  config,
  localizedTime,
  initLoginlessSubscription,
  navigateTo,
  member
}) => {
  const rows = get(config, ['pagebuilder-config', 'subscription', 'rows']) || get(subscriptionConfig, ['rows']) || [];
  const subRowIndex = rows.findIndex(isSubscriptionRow);

  let rowsBefore = [];
  let rowsAfter = [];

  if (!isPB) {
    if (subRowIndex !== -1) {
      rowsBefore = rows.slice(0, subRowIndex);
      rowsAfter = rows.slice(subRowIndex + 1);
    } else {
      rowsAfter = rows.filter((r) => isAdRow(r) || isWidgetRow(r));
    }
  }

  return (
    <React.Fragment>
      {rowsBefore.map(renderRow)}
      <div styleName={`component-wrapper ${mode === 'dark' ? 'dark' : ''} ${isPB ? 'is-pb' : ''}`}>
      <div styleName="headblock-wrapper">
          <HeadBlock subscriptionConfig={subscriptionConfig} mode={mode} isLoginless={true} />
        </div>
      <div styleName="layout">
        <div styleName="left-column">
          <div styleName={`left-column-card plan-selection-card ${mode === 'dark' ? 'dark' : ''}`}>
            {children}
          </div>

          <div styleName={`left-column-card order-summary-card ${mode === 'dark' ? 'dark' : ''}`}>
              <OrderSummarySection
                plan={activePlan}
                subscriptionConfig={subscriptionConfig}
                mode={mode}
                localizedTime={localizedTime}
                isPB={isPB}
                config={config}
              />

              {description && (
              <div styleName="dynamic-description-container">
                  <Description
                    data={description}
                    descriptionTitle={subscriptionConfig?.descriptionTitle}
                    mode={mode}
                    type={descriptionType}
                    displayDescription={true}
                  />
                </div>
              )}
            </div>
          </div>

        <div styleName="right-column-card">
            <CheckoutPanel
              selectedPlan={activePlan}
              subscriptionConfig={subscriptionConfig}
              config={config}
              localizedTime={localizedTime}
              mode={mode}
              initLoginlessSubscription={initLoginlessSubscription}
              navigateTo={navigateTo}
              member={member}
              isPB={isPB}
            />
          </div>
        </div>
      </div>
      {rowsAfter.map(renderRow)}
    </React.Fragment>
  );
};

LoginlessLayout.propTypes = {
  children: PropTypes.node.isRequired,
  subscriptionConfig: PropTypes.object,
  mode: PropTypes.string,
  isPB: PropTypes.bool,
  activePlan: PropTypes.object,
  description: PropTypes.any,
  descriptionType: PropTypes.string,
  config: PropTypes.object,
  localizedTime: PropTypes.string,
  initLoginlessSubscription: PropTypes.func,
  navigateTo: PropTypes.func,
  member: PropTypes.object
};
